import React from 'react'
import { connect } from 'react-redux'

import { daysLeftInCycleCombine } from 'helpers/cycles';
import { getAllBypassedSubscriptions, getAllQuickSubscriptions } from 'reducers';
import ProgressMeter from 'common/ProgressMeter';
import { pluralize, percent } from 'helpers/formatters';
import cycle_icon from './cycle_icon.svg';

import styles from './index.module.css';

function DaysLeft({ daysLeft }) {
  if (daysLeft === null) {
    return null;
  }

  return (
    <React.Fragment>
      <div className={styles.cycle}>
        <img src={cycle_icon} alt="" />
        {daysLeft} {pluralize('day', daysLeft)} left in cycle
      </div>
      <ProgressMeter percent={percent(31 - daysLeft, 31)} progress="#5f90ff" remaining="#e5e5e5" full="#5f90ff" />
    </React.Fragment>
  )
}

const filterByStatuses = (subs, statuses, statusKey) => {
  return subs.filter(sub => statuses.includes(sub[statusKey]))
}

const mapStateToProps = (state) => {
  const subStatuses = ['active', 'suspended'];
  let bypassedSubs = getAllBypassedSubscriptions(state);
  let quickSubs = getAllQuickSubscriptions(state);
  if (subStatuses) {
    bypassedSubs = filterByStatuses(bypassedSubs, subStatuses, 'bypassed_status');
    quickSubs = filterByStatuses(quickSubs, subStatuses, 'quick_status');
  }

  const daysLeft = daysLeftInCycleCombine({ bypassedSubs, quickSubs });

  return {
    daysLeft,
  }
}

export default connect(mapStateToProps, null)(DaysLeft);